import React, { memo } from "react";

function PopupEspecial({
  mostrar,
  especial,
  onCerrar,
  onClick,
  onAnterior,
  onSiguiente,
  cantidad,
  index,
}) {
  if (!mostrar || !especial) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.55)",
        zIndex: 99999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "18px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          backgroundColor: "#fff",
          borderRadius: "22px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <button
          onClick={onCerrar}
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            zIndex: 5,
            backgroundColor: "rgba(0,0,0,0.6)",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "34px",
            height: "34px",
            cursor: "pointer",
            fontWeight: "900",
          }}
        >
          ✕
        </button>

        <div
          onClick={onClick}
          style={{
            cursor: "pointer",
          }}
        >
          {especial.tipo === "video" ? (
            <video
              src={especial.url}
              autoPlay
              muted
              loop
              playsInline
              style={{
                width: "100%",
                height: "250px",
                objectFit: "cover",
                display: "block",
              }}
            />
          ) : (
            <img
              src={especial.url}
              alt=""
              loading="lazy"
              decoding="async"
              style={{
                width: "100%",
                height: "250px",
                objectFit: "cover",
                display: "block",
              }}
            />
          )}

          <div
            style={{
              padding: "18px",
            }}
          >
            <h2
              style={{
                margin: "0 0 8px 0",
                fontSize: "22px",
                fontWeight: "900",
              }}
            >
              {especial.titulo}
            </h2>

            <p
              style={{
                margin: 0,
                color: "#666",
                lineHeight: "1.4",
                fontSize: "14px",
              }}
            >
              {especial.descripcion}
            </p>

            <button
              style={{
                marginTop: "18px",
                width: "100%",
                border: "none",
                backgroundColor: "#111",
                color: "#fff",
                borderRadius: "14px",
                padding: "14px",
                fontWeight: "800",
                cursor: "pointer",
              }}
            >
              VER PROMOCIÓN
            </button>
          </div>
        </div>

        {cantidad > 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 18px 18px 18px",
            }}
          >
            <button
              onClick={onAnterior}
              style={{
                border: "none",
                background: "none",
                fontSize: "24px",
                cursor: "pointer",
              }}
            >
              ←
            </button>

            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: "#777",
              }}
            >
              {index + 1} / {cantidad}
            </span>

            <button
              onClick={onSiguiente}
              style={{
                border: "none",
                background: "none",
                fontSize: "24px",
                cursor: "pointer",
              }}
            >
              →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(PopupEspecial);
